<div class="non-partner-direct-login-container">
    <form [formGroup]="formGroup">
        <div class="font-14 padding flex-centered-container-vr mat-icon-20">
            <span>Login Broker</span>
        </div>
        <mat-divider></mat-divider>
        <div class="flex-centered-container-vr margin-vr padding-left">
            <img [src]="data.brokerDetails.image_link" alt="broker-logo" class="img-48-sq margin-4-right">
            <div class="display-flex-column dynamic-font-12">
                <span>{{ data.brokerDetails.display_name }}</span>
                <span class="decoration-underline cursor-pointer text-accent" (click)="openHelp()">How to login to {{
                    data.brokerDetails.display_name }} broker?</span>
            </div>
        </div>
        <ng-container *ngFor="let field of data.brokerDetails.login_fields">
            <div class="display-flex-column margin-vr padding-left dynamic-font-12">
                <span class="margin-4-bottom">Enter your {{ field.label }}</span>
                <div class="input-with-icon-wrapper">
                    <input [formControlName]="field.name"
                        [readonly]="field.readonly"
                        [type]="field.sensitive && !isFieldVisible(field.name) ? 'password' : 'text'"
                        class="font-12 border-field pad-8 input-field-width re-name-input" [ngClass]="{'sensitive-input': field.sensitive}"
                        [class.input-with-suffix]="field.sensitive"
                        placeholder="Enter {{ field.label }}">
                    <mat-icon *ngIf="field.sensitive" matTooltip="{{ isFieldVisible(field.name) ? 'Hide' : 'Show' }}"
                        class="toggle-visibility-icon cursor-pointer" (click)="toggleFieldVisibility(field.name)">
                        {{ isFieldVisible(field.name) ? 'visibility' : 'visibility_off' }}
                    </mat-icon>
                </div>
            </div>
        </ng-container>
        <button mat-flat-button color="accent" class="submit-button dynamic-font-12 flex-centered-container new-theme-gradient-bg margin-left margin-bottom"
            (click)="saveBroker()" [disabled]="formGroup.invalid">Login with {{ data.brokerDetails.display_name }}
            Account</button>
    </form>
</div>